module.exports = "../dist/img/423x544_8.6639.jpg";